import React from 'react';
import BusinessCard from './components/BusinessCard';
import './CardPage.css';
import AppLinks from './components/AppLinks';

export default function CardPage() {
  return (
    <div className="card-page">
      <div className="card-page__inner">

        {/* Subtle header */}
        <div className="card-page__header">
          <div className="card-page__rule">
            <span className="card-page__rule-line" />
            <span className="card-page__rule-diamond" />
            <span className="card-page__rule-line" />
          </div>
        </div>

        {/* The card itself */}
        <BusinessCard mode="standalone" />

        {/* Hint text */}
        <div className="card-page__footer">
          <p className="card-page__hint">
            Tap card to reveal contact details &nbsp;·&nbsp; Tap again to save
          </p>
          <div className="card-page__rule">
            <span className="card-page__rule-line" />
            <span className="card-page__rule-diamond" />
            <span className="card-page__rule-line" />
          </div>
          <p className="card-page__links">
            <AppLinks current="card" />
          </p>
        </div>

      </div>
    </div>
  );
}
